import React from "react";
import ReactDOM from "react-dom/client";
import Home from "./pages/Home/Home";

import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider, ScrollRestoration } from "react-router-dom";
import Resume from "./pages/Resume/Resume";
import Projects from "./pages/Projects/Projects";
import NotFoundPage from "./NotFoundPage";
import FoodBlogShowCase from "./pages/FoodBlogShowCase/FoodBlogShowcase";
import StockPortfolioManagerShowCase from "./pages/StockShowcase/StockShowcase";
const router = createBrowserRouter([
	{ path: "/", element: <Home /> },
	{ path: "/projects", element: <Projects /> },
	{ path: "/resume", element: <Resume /> },
	{ path: "/food-blog-showcase", element: <FoodBlogShowCase /> },
	{ path: "/stock-portfolio-manager-showcase", element: <StockPortfolioManagerShowCase /> },
	{ path: "*", element: <NotFoundPage /> },
]);
const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
